<template>
  <div class="col-lg col-md-6 col-sm-6 mb-4">
    <div class="stats-small stats-small--1 card card-small">
      <div class="card-body p-0 d-flex">
        <div class="d-flex flex-column m-auto">
          <div class="stats-small__data text-center">
            <span class="stats-small__label text-uppercase">{{ name }}</span>
            <h6 class="stats-small__value count my-3">{{ data }}</h6>
          </div>
        </div>
        <canvas height="120" class="blog-overview-stats-small-1"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		props: ['name', 'endpoint'],

		data() {
			return {
				data: []
			}
		},

		mounted() {
			this.getData();
		},

		methods: {
			async getData() {
				let url = process.env.VUE_APP_ROOT_API.concat(this.$props.endpoint);
				let response = await fetch(url);
				this.data = await response.json();
			}
		}
	}
</script>